import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Item = ({ slug, title, image, bodyContent }) => {
  const { file: { url, fileName } } = image
  return (
    <div className='col-lg-4 col-md-6'>
      <div className='blog-post icon-text layout-7 wow zoomIn' data-wow-delay='0.2s'>
        <Link to={`/post/${slug}`}>
          <div className='icon'>
            <img src={url} alt={fileName} />
          </div>
          <div className='link truncate-title'>{title}</div>
          <div className='text truncate-text' dangerouslySetInnerHTML={{ __html: bodyContent.childMarkdownRemark.html }} />
          <span className='more'>Read More</span>
        </Link>
      </div>
    </div>
  )
}

Item.propTypes = {
  bodyContent: PropTypes.shape(),
  title: PropTypes.string,
  slug: PropTypes.string,
  image: PropTypes.shape()
}

Item.defaultProps = {
  bodyContent: {},
  title: '',
  slug: '',
  image: {}
}

export default Item
